export const baseFormColumn = (ctx) => {
  return [
    {
      prop: 'billNo',
      name: '监管单号',
      type: 'input',
    },
    {
      prop: 'billStatus',
      name: '监管单状态',
      type: 'select',
      options: ctx.supervisionBillStatusList,
      currentValue: ctx.billStatus,
    },
    {
      prop: 'contractNo',
      name: '监管合同号',
      type: 'input',
    },
    {
      prop: 'parkCompanyName',
      name: '园区公司',
      type: 'input',
    },
    {
      prop: 'gmtCreate',
      name: '创建日期',
      type: 'input',
    },
    {
      prop: 'fullWarehousTime',
      name: '完全入库时间',
      type: 'input',
    },
    {
      prop: 'fullDeliveryTime',
      name: '完全出库时间',
      type: 'input',
    },
    {
      prop: 'parkDepartmentName',
      name: '业务部门',
      type: 'input',
    },
    {
      prop: 'goodsType',
      name: '货物类型',
      type: 'select',
      currentValue: ctx.billStatus,
      options: ctx.goodsTypeList,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'goodsCategory',
      name: '货物品类',
      type: 'select',
      placeholder: '请选择货物品类',
      currentValue: ctx.goodsCategory,
      options: ctx.goodsCategoryList,
      multiple: true,
      disabled: ctx.baseFormData.goodsType == '',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractQuantity',
      name: '货物总数量/重量',
      type: 'input',
    },
    {
      prop: 'operatorName',
      name: '操作人',
      type: 'input',
    },
    {
      name: '出质方名称',
      prop: 'pledgorName',
      type: 'searchTableSpec',
      searchType: 'partner',
      currentValue: ctx.baseFormData.pledgorName,
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'pledgorNo',
      name: '出质方编码',
      type: 'input',
    },
    {
      name: '质权方名称',
      prop: 'pledgeeName',
      type: 'searchTableSpec',
      searchType: 'partner',
      currentValue: ctx.baseFormData.pledgeeName,
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'pledgeeNo',
      name: '质权方编码',
      type: 'input',
    },
    {
      name: '关联方名称',
      prop: 'relatedName',
      type: 'searchTableSpec',
      searchType: 'partner',
      currentValue: ctx.baseFormData.relatedName,
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'relatedNo',
      name: '关联方编码',
      type: 'input',
    },
    {
      prop: 'unit',
      name: '单位',
      type: 'input',
    },
    {
      prop: 'remark',
      name: '备注',
      type: 'input',
    },
  ];
};

export const baseFormColumn1 = (ctx) => {
  return [
    {
      prop: 'parkCompanyName',
      name: '园区公司',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'parkDepartmentName',
      name: '业务部门',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'operatorName',
      name: '操作人',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'contractNo',
      name: '监管合同号',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'gmtCreate',
      name: '创建日期',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'goodsType',
      name: '货物类型',
      type: 'select',
      options: ctx.goodsTypeList,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'goodsCategory',
      name: '货物品类',
      type: 'select',
      placeholder: '请选择货物品类',
      options: ctx.goodsCategoryList,
      multiple: true,
      disabled: ctx.baseFormData.goodsType == '',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractQuantity',
      name: '合同总重量/数量',
      type: 'inputNumber',
      disabled: true,
    },
    {
      name: '出质方名称',
      prop: 'pledgorName',
      type: 'searchTableSpec',
      searchType: 'partner',
      currentValue: ctx.baseFormData.pledgorName,
      isMultiple: true,
      disabled: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'pledgorNo',
      name: '出质方编码',
      type: 'input',
      disabled: true,
    },
    {
      name: '质权方名称',
      prop: 'pledgeeName',
      type: 'searchTableSpec',
      searchType: 'partner',
      currentValue: ctx.baseFormData.pledgeeName,
      isMultiple: true,
      disabled: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'pledgeeNo',
      name: '质权方编码',
      type: 'input',
      disabled: true,
    },
    {
      name: '关联方名称',
      prop: 'relatedName',
      type: 'searchTableSpec',
      searchType: 'partner',
      currentValue: ctx.baseFormData.relatedName,
      isMultiple: true,
      disabled: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'relatedNo',
      name: '关联方编码',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'remark',
      name: '备注',
      type: 'input',
    },
  ];
};

export const baseFormRules = () => {
  return {
    parkCompanyName: [{ required: true, message: '园区公司必填', trigger: ['change', 'blur'] }],
    parkDepartmentName: [{ required: true, message: '业务部门必填', trigger: ['change', 'blur'] }],
    goodsType: [{ required: true, message: '货物类型必填', trigger: ['change', 'blur'] }],
  };
};
